exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".atlas-grid[data-v-5085d6c2]{margin:8px 0}.atlas-grid__table-header[data-v-5085d6c2]{margin-bottom:8px;padding:6px;background:var(--white-bg);text-align:center;font-size:14px;line-height:20px;letter-spacing:1px;font-weight:bold}", ""]);

